import { z } from "zod";

import {
	AssignStatus,
	InclusionFilterStatus,
	PriorityFilterStatus,
	SelectType,
} from "@/enum/list.enum";

import { selectAllScopeFields } from "./select-all-scope.schema";

export const BulkAddToTrackerSchema = z.object({
	listId: z.number(),
	listPersonIds: z.array(z.number()),
	selectType: z.nativeEnum(SelectType).optional(),
	inclusionFilterStatus: z.array(z.nativeEnum(InclusionFilterStatus)).optional(),
	filter: z.record(z.string(), z.any()).optional(),
	priorityFilterStatus: z.array(z.nativeEnum(PriorityFilterStatus)).optional(),
	assignStatus: z.array(z.nativeEnum(AssignStatus)).optional(),
	/** The table's search, tab statuses, reason sub-filters and signal filter (PREC-4443, PREC-4450). */
	...selectAllScopeFields,
});

export const BulkAddCompanyToTrackerSchema = z.object({
	listId: z.number(),
	listPersonIds: z.array(z.number()),
	selectType: z.nativeEnum(SelectType).optional(),
	inclusionFilterStatus: z.array(z.nativeEnum(InclusionFilterStatus)).optional(),
	filter: z.record(z.string(), z.any()).optional(),
	priorityFilterStatus: z.array(z.nativeEnum(PriorityFilterStatus)).optional(),
	assignStatus: z.array(z.nativeEnum(AssignStatus)).optional(),
	/** The table's search, tab statuses, reason sub-filters and signal filter (PREC-4443, PREC-4450). */
	...selectAllScopeFields,
});

export const BulkAddToWebhookSchema = z.object({
	webhookId: z.number(),
	listPersonIds: z.array(z.number()),
	selectType: z.nativeEnum(SelectType).optional(),
	inclusionFilterStatus: z.array(z.nativeEnum(InclusionFilterStatus)).optional(),
	filter: z.record(z.string(), z.any()).optional(),
	priorityFilterStatus: z.array(z.nativeEnum(PriorityFilterStatus)).optional(),
	assignStatus: z.array(z.nativeEnum(AssignStatus)).optional(),
	/** The table's search, tab statuses, reason sub-filters and signal filter (PREC-4443, PREC-4450). */
	...selectAllScopeFields,
});

export const BulkSearchForEmailsSchema = z.object({
	ids: z.array(z.number()),
	listId: z.number().optional(),
	selectType: z.nativeEnum(SelectType).optional(),
	inclusionFilterStatus: z.array(z.nativeEnum(InclusionFilterStatus)).optional(),
	filter: z.record(z.string(), z.any()).optional(),
	priorityFilterStatus: z.array(z.nativeEnum(PriorityFilterStatus)).optional(),
	assignStatus: z.nativeEnum(AssignStatus).optional(),
	...selectAllScopeFields,
});

export const BulkSearchForPhonesSchema = z.object({
	ids: z.array(z.number()),
	listId: z.number().optional(),
	selectType: z.nativeEnum(SelectType).optional(),
	inclusionFilterStatus: z.array(z.nativeEnum(InclusionFilterStatus)).optional(),
	filter: z.record(z.string(), z.any()).optional(),
	priorityFilterStatus: z.array(z.nativeEnum(PriorityFilterStatus)).optional(),
	assignStatus: z.nativeEnum(AssignStatus).optional(),
	...selectAllScopeFields,
});

export const BulkSearchForCompanyEmailAndPhoneSchema = z.object({
	ids: z.array(z.number()),
	listId: z.number().optional(),
	selectType: z.nativeEnum(SelectType).optional(),
	inclusionFilterStatus: z.array(z.nativeEnum(InclusionFilterStatus)).optional(),
	filter: z.record(z.string(), z.any()).optional(),
	priorityFilterStatus: z.array(z.nativeEnum(PriorityFilterStatus)).optional(),
	assignStatus: z.nativeEnum(AssignStatus).optional(),
	...selectAllScopeFields,
});

export type BulkAddToTracker = z.infer<typeof BulkAddToTrackerSchema>;

export type BulkAddCompanyToTracker = z.infer<typeof BulkAddCompanyToTrackerSchema>;

export type BulkAddToWebhook = z.infer<typeof BulkAddToWebhookSchema>;

export type BulkSearchForEmails = z.infer<typeof BulkSearchForEmailsSchema>;

export type BulkSearchForPhones = z.infer<typeof BulkSearchForPhonesSchema>;

export type BulkSearchForCompanyEmailAndPhone = z.infer<
	typeof BulkSearchForCompanyEmailAndPhoneSchema
>;
